export const ROLE_KEYWORD_MAP_FOR_SEO = {
  'Accountant' : {
    'title' : 'Accountant, Finance, CS, CA',
    'description' : 'Accountant, finance, CS, CA, tax and audit',
    'h1' : 'Accountant Jobs'
  },
  'Architect' : {
    'title' : 'Architecture, Interior Designer',
    'description' : 'Architect and interior designer',
    'h1' : 'Architecture Jobs'
  },
  'Beautician' : {
    'title' : 'Beautician, Hairdresser, Salon',
    'description' : 'Beautician jobs, hairdresser, hair stylist, jobs in beauty parlors and salons',
    'h1' : 'Beautician Jobs'
  },
  'BPO/ Telecaller' : {
    'title' : 'Call Center, BPO, KPO, Customer Care',
    'description' : 'Call center, BPO/KPO, customer care',
    'h1' : 'BPO/Call-Center Jobs'
  },
  'Cashier' : {
    'title' : 'Cashier, Bank Cashier',
    'description' : 'Cashier, Bank cashier',
    'h1' : 'Cashier Jobs'
  },
  'Construction/Laborer' : {
    'title' : 'Construction Jobs, Worker, Daily Labour',
    'description' : 'Construction jobs, construction workers, labour, farmer and cultivator',
    'h1' : 'Construction Jobs'
  },
  'Content Writer' : {
    'title' : 'Content Writer, Web Content Writer, Journalist',
    'description' : 'Content writer, journalist, columnist & news writer',
    'h1' : 'Content Writer Jobs'
  },
  'Cook' : {
    'title' : 'Cooks & Chef, Private Chef',
    'description' : 'Cook and chef, private chef , multi cuisine cook',
    'h1' : 'Cook and Chef Jobs'
  },
  'Data Entry /Back Office' : {
    'title' : 'Data Entry, Back Office',
    'description' : 'Data entry, back office, online data entry',
    'h1' : 'Data Entry Jobs'
  },
  'Delivery/Collections' : {
    'title' : 'Delivery, Courier, Delivery Boy',
    'description' : 'Delivery, Couriers, delivery boy/courier boy',
    'h1' : 'Delivery and Courier Jobs'
  },
  'Driver' : {
    'title' : 'Drivers, Truck Drivers, Private Driver',
    'description' : 'Drivers, Truck Drivers, Private Driver',
    'h1' : 'Driver Jobs'
  },
  'DTP Operator/Print Consultant' : {
    'title' : 'DTP Operator Jobs, Print Consultant',
    'description' : 'Find DTP operator & print consultant jobs. Searching job is no more difficult as Quikr offer you number of opportunities.',
    'h1' : 'DTP Operator/Print Consultant Jobs'
  },
  'Engineer' : {
    'title' : 'Engineering',
    'description' : 'Engineering',
    'h1' : 'Engineering Jobs'
  },
  'Hospitality Executive' : {
    'title' : 'Hospitality, Supervisor, Steward',
    'description' : 'Hospitality, supervisor and steward',
    'h1' : 'Hospitality Jobs'
  },
  'HR/Admin' : {
    'title' : 'HR & Admin',
    'description' : 'HR and Admin',
    'h1' : 'HR and Admin Jobs'
  },
  'Maid' : {
    'title' : 'Maids, Housekeepers',
    'description' : 'Maid and housekeeper',
    'h1' : 'Maid and Housekeeper Jobs'
  },
  'Sales' : {
    'title' : 'Sales, Sales Executive, Sales Managers',
    'description' : 'Sales agent, sales manager, sales executive',
    'h1' : 'Sales Jobs'
  },
  'Security/Guard' : {
    'title' : 'Security Guard Jobs, Security Supervisor',
    'description' : 'Security guard jobs, security supervisor',
    'h1' : 'Security Jobs'
  },
  'Warehouse Executive' : {
    'title' : 'Warehouse Executives',
    'description' : 'Warehouse executive',
    'h1' : 'Warehouse Jobs'
  },
  'Teacher' : {
    'title' : 'Teacher, Tutor, Online Tutor',
    'description' : 'Teaching and tutor job',
    'h1' : 'Teacher Jobs'
  },
  'Tailor' : {
    'title' : 'Tailor, Fashion Designing, Boutique',
    'description' : 'Tailoring, fashion designing, dress making',
    'h1' : 'Tailor Jobs'
  },
  'Receptionist/Front Office' : {
    'title' : 'Receptionist',
    'description' : 'Receptionist, front office manager',
    'h1' : 'Receptionist Jobs'
  },
  'Office Assistant/Helper' : {
    'title' : 'Office Boy, Office Assistant, Office Helpers',
    'description' : 'Office boy, office assistant and office helper',
    'h1' : 'Office Assistant Jobs'
  },
  'Nurse' : {
    'title' : 'Nurse, MR, Healthcare',
    'description' : 'Nursing, MR (medical representative}, health care',
    'h1' : 'Healthcare Jobs'
  },
  'Mechanic' : {
    'title' : 'Mechanic Jobs, Auto Mechanic, Diesel Mechanic',
    'description' : 'Mechanic Jobs, Auto Mechanic, Diesel Mechanic',
    'h1' : 'Mechanic Jobs'
  },
  'Marketing' : {
    'title' : 'Marketing, Advertising & Media',
    'description' : 'Marketing, advertising & media',
    'h1' : 'Marketing Jobs'
  },
  'Legal' : {
    'title' : 'Lawyers, Legal Secretary',
    'description' : 'Legal sector like lawyers, legal secretary',
    'h1' : 'Legal Sector Jobs'
  },
  'IT Software - Developer' : {
    'title' : 'IT Software, Engineer',
    'description' : 'IT - software developer',
    'h1' : 'IT Software Developer Jobs'
  },
  'IT Hardware & Network Engineer' : {
    'title' : 'IT Hardware & Network Engineer',
    'description' : 'Hardware and networking',
    'h1' : 'IT Hardware-Network Jobs'
  },
  'IT Software - Web Designer' : {
    'title' : 'Web Designer, Graphic Designer',
    'description' : 'Web designer, graphic designer',
    'h1' : 'IT Software - Web Designer Jobs'
  },
  'IT Software - QA/Test Engineer' : {
    'title' : 'Software Testing, Software QA & QC',
    'description' : 'Software testing, Software QA and QC',
    'h1' : 'IT Software - Testing Jobs'
  },
  'Others' : {
    'title' : 'Full Time, Part Time',
    'description' : 'Find full time, part time, work from home, online opportunities',
    'h1' : 'Full Time, Part Time Jobs'
  },
  'Photographer' : {
    'title' : 'Photographer Jobs, Photography, Fashion Photographer',
    'description' : 'Photographer Jobs, Photography, Fashion Photographer',
    'h1' : 'Photographer Jobs'
  },
  'Gardener' : {
    'title' : 'Gardener Jobs, Gardening',
    'description' : 'Gardener Jobs, Gardening',
    'h1' : 'Gardener Jobs'
  },
  'Painter' : {
    'title' : 'Painter Jobs, Wall Painter, Portrait Painter',
    'description' : 'Painter Jobs, Wall Painter, Portrait Painter',
    'h1' : 'Painter Jobs'
  },
  'Trainer' : {
    'title' : 'Trainer Job, Gym Trainer, Dance Trainer',
    'description' : 'Trainer Job, Gym Trainer, Dance Trainer',
    'h1' : 'Trainer Job'
  },
  'Electrician' : {
    'title' : 'Electrician Jobs, ITI Electrician, Electrical',
    'description' : 'Electrician Jobs, ITI Electrician, Electrical',
    'h1' : 'Electrician Jobs'
  },
  'Plumber' : {
    'title' : 'Plumber Jobs, Plumbing',
    'description' : 'Plumber Jobs, Plumbing',
    'h1' : 'Plumber Jobs'
  },
  'Carpenter' : {
    'title' : 'Carpenter Jobs, Carpentry',
    'description' : 'Carpenter Jobs, Carpentry',
    'h1' : 'Carpenter Jobs'
  },
  'Doctor' : {
    'title' : 'Doctor Jobs, MBBS Doctor',
    'description' : 'Doctor Jobs, MBBS Doctor',
    'h1' : 'Doctor Jobs'
  },
  'Government Jobs' : {
    'title' : 'Sarkari Naukri, Govt Jobs in <city>, Govt Jobs 2016-17',
    'description' : "Find all Govt jobs, Sarkari Naukri vacancies, latest govt listings in <city> at QuikrJobs. Get details of all central & state Govt jobs, apply for Sarkari Naukri.",
    'h1' : 'Govt Jobs'
  },
  'Bartender' : {
    'title' : 'Bartender',
    'description' : 'Bartender',
    'h1' : 'Bartender Jobs'
  },
  'Bouncer' : {
    'title' : 'Bouncer',
    'description' : 'Bouncer',
    'h1' : 'Bouncer Jobs'
  },
  'Caretaker/Nanny' : {
    'title' : 'Caretaker, Nanny',
    'description' : 'Caretaker, Nanny',
    'h1' : 'Caretaker/Nanny Jobs'
  },
  'Counsellor' : {
    'title' : 'Counsellor',
    'description' : 'Counsellor',
    'h1' : 'Counsellor Jobs'
  },
  'Pharmacist' : {
    'title' : 'Pharmacist, Chemist, Pharma',
    'description' : 'Pharmacist, Chemist, Pharma',
    'h1' : 'Pharmacist Jobs'
  },
  'Animation' : {
    'title' : 'Animation Jobs, Graphic Designer',
    'description' : 'Animation Jobs, Graphic Designer',
    'h1' : 'Animation Jobs'
  },
  'Data Collection/Survey' : {
    'title' : 'Data Collection Jobs, Field Survey',
    'description' : 'Data Collection Jobs, Field Survey',
    'h1' : 'Data Collection/Survey Jobs'
  },
  'Porter' : {
    'title' : 'Porter Jobs, Hospital Porter, Maintenance Porter',
    'description' : 'Porter Jobs, Hospital Porter, Maintenance Porter',
    'h1' : 'Porter Jobs'
  },
  'Handyman' : {
    'title' : 'Handyman Jobs, Repair Work, Maintenance',
    'description' : 'Handyman Jobs, Repair Work, Maintenance',
    'h1' : 'Handyman Jobs'
  },
  'Sound Engineer' : {
    'title' : 'Sound Engineer Jobs, Audio Engineer, Studio Sound Engineer',
    'description' : 'Sound Engineer Jobs, Audio Engineer, Studio Sound Engineer',
    'h1' : 'Sound Engineer Jobs'
  },
  'Cameraman' : {
    'title' : 'Cameraman',
    'description' : 'Cameraman',
    'h1' : 'Cameraman Jobs'
  },
  'Lighting Man' : {
    'title' : 'Lighting Man Jobs, Lighting Technician, Lighting Supervisor',
    'description' : 'Lighting Man Jobs, Lighting Technician, Lighting Supervisor',
    'h1' : 'Lighting Man Jobs'
  },
  'Videographer' : {
    'title' : 'Videographer',
    'description' : 'Videographer',
    'h1' : 'Videographer Jobs'
  },
  'Dubbing Artist' : {
    'title' : 'Dubbing Artist Jobs, Voice Artist',
    'description' : 'Dubbing Artist Jobs, Voice Artist',
    'h1' : 'Dubbing Artist Jobs'
  },
  'Projectionist' : {
    'title' : 'Projectionist Jobs, Cinema/Film Projectionist',
    'description' : 'Projectionist Jobs, Cinema/Film Projectionist',
    'h1' : 'Projectionist Jobs'
  },
  'Medical Assistant' : {
    'title' : 'Medical Assistant Job, Lab Assistant',
    'description' : 'Medical Assistant Job, Lab Assistant',
    'h1' : 'Medical Assistant Jobs'
  },
  'Nutritionist/Dietician' : {
    'title' : 'Dietician Jobs, Nutritionist',
    'description' : 'Dietician Jobs, Nutritionist',
    'h1' : 'Nutritionist/Dietician Jobs'
  },
  'Financial  Advisor' : {
    'title' : 'Financial  Advisor',
    'description' : 'Financial  Advisor',
    'h1' : 'Financial  Advisor Jobs'
  },
  'Insurance Consultant' : {
    'title' : 'Insurance Consultant',
    'description' : 'Insurance Consultant',
    'h1' : 'Insurance Consultant Jobs'
  },
  'Language Translator' : {
    'title' : 'Translator Jobs, Language Translator',
    'description' : 'Translator Jobs, Language Translator',
    'h1' : 'Language Translator Jobs'
  },
  'Public Relations' : {
    'title' : 'PR Jobs',
    'description' : 'PR Jobs',
    'h1' : 'Public Relations Jobs'
  },
  'Editor' : {
    'title' : 'Editor Jobs, Proofreading, Copy Editor',
    'description' : 'Editor Jobs, Proofreading, Copy Editor',
    'h1' : 'Editor Jobs'
  },
  'Reporter' : {
    'title' : 'Reporter Jobs, News, TV Reporter, Journalism',
    'description' : 'Reporter Jobs, News, TV Reporter, Journalism',
    'h1' : 'Reporter Jobs'
  },
  'Fitter' : {
    'title' : 'Fitter Jobs, ITI Fitter',
    'description' : 'Fitter Jobs, ITI Fitter',
    'h1' : 'Fitter Jobs'
  },
  'Welder' : {
    'title' : 'Welder Jobs, Structural Welding, Pipe Welding',
    'description' : 'Welder Jobs, Structural Welding, Pipe Welding',
    'h1' : 'Welder Jobs'
  },
  'Foundryman' : {
    'title' : 'Foundryman Jobs, ITI Foundryman, Moulder',
    'description' : 'Foundryman Jobs, ITI Foundryman, Moulder',
    'h1' : 'Foundryman Jobs'
  },
  'Dye Maker' : {
    'title' : 'Dye Maker',
    'description' : 'Dye Maker',
    'h1' : 'Dye Maker Jobs'
  },
  'Draftsman' : {
    'title' : 'Draftsman',
    'description' : 'Draftsman',
    'h1' : 'Draftsman Jobs'
  },
  'Scientist-Research' : {
    'title' : 'Scientist Jobs, Research, Science',
    'description' : 'Scientist Jobs, Research, Science',
    'h1' : 'Scientist-Research Jobs'
  },
  'Event Planner' : {
    'title' : 'Event Management Jobs, Event Planner, Wedding Planner',
    'description' : 'Event Management Jobs, Event Planner, Wedding Planner',
    'h1' : 'Event Planner Jobs'
  },
  'Librarian' : {
    'title' : 'Librarian',
    'description' : 'Librarian',
    'h1' : 'Librarian Jobs'
  },
  'Designer' : {
    'title' : 'Jewellery Designer Jobs, Fashion Designer',
    'description' : 'Jewellery Designer Jobs, Fashion Designer',
    'h1' : 'Designer Jobs'
  },
  'Waiter/Steward' : {
    'title' : 'Waiter Jobs, Steward, Hotel Staff',
    'description' : 'Waiter Jobs, Steward, Hotel Staff',
    'h1' : 'Waiter/Steward Jobs'
  },
  'Cleaner/Washer' : {
    'title' : 'Cleaner',
    'description' : 'Cleaner',
    'h1' : 'Cleaner/Washer Jobs'
  },
  'Operator/Machinist' : {
    'title' : 'Machinist Jobs, CNC, Milling Machine',
    'description' : 'Machinist Jobs, CNC, Milling Machine',
    'h1' : 'Operator/Machinist Jobs'
  },
  'Host/Hostess' : {
    'title' : 'Air Hostess Jobs, Airport Ground Staff, Flight Attendant',
    'description' : 'Air Hostess Jobs, Airport Ground Staff, Flight Attendant',
    'h1' : 'Host/Hostess Jobs'
  },
  'Electroplater' : {
    'title' : 'Electroplating',
    'description' : 'Electroplating',
    'h1' : 'Electroplater Jobs'
  },
  'Quality and Inspection' : {
    'title' : 'Quality Testing Jobs, Inspection',
    'description' : 'Quality Testing Jobs, Inspection',
    'h1' : 'Quality and Inspection Jobs'
  },
  'Sheet Metal Worker' : {
    'title' : 'Sheet Metal',
    'description' : 'Sheet Metal',
    'h1' : 'Sheet Metal Worker Jobs'
  },
  'Wireman' : {
    'title' : 'Wireman Jobs, ITI Wireman',
    'description' : 'Wireman Jobs, ITI Wireman',
    'h1' : 'Wireman Jobs'
  },
  'Moulder' : {
    'title' : 'Moulder Jobs, Injection Moulding',
    'description' : 'Moulder Jobs, Injection Moulding',
    'h1' : 'Moulder Jobs'
  },
  'Microbiologist' : {
    'title' : 'Microbiology Jobs, Biotechnology',
    'description' : 'Microbiology Jobs, Biotechnology',
    'h1' : 'Microbiologist Jobs'
  },
  'Ticketing Executive' : {
    'title' : 'Ticket Counter Jobs, Air Ticketing, Railway Ticketing',
    'description' : 'Ticket Counter Jobs, Air Ticketing, Railway Ticketing',
    'h1' : 'Ticketing Executive Jobs'
  },
  'Floor Manager' : {
    'title' : 'Resturant Manager Jobs, Retail Store Manager',
    'description' : 'Resturant Manager Jobs, Retail Store Manager',
    'h1' : 'Floor Manager Jobs'
  },
  'Rigger' : {
    'title' : 'Rigger Jobs, Oil Rig',
    'description' : 'Rigger Jobs, Oil Rig',
    'h1' : 'Rigger Jobs'
  },
  'Lighting Technician' : {
    'title' : 'Lighting Technician',
    'description' : 'Lighting Technician',
    'h1' : 'Lighting Technician Jobs'
  },
  'Optometrist' : {
    'title' : 'Optometrist Jobs, Optician',
    'description' : 'Optometrist Jobs, Optician',
    'h1' : 'Optometrist Jobs'
  },
  'Lab Assistant' : {
    'title' : 'Lab Technician Jobs, Lab Assistant, Medical Lab',
    'description' : 'Lab Technician Jobs, Lab Assistant, Medical Lab',
    'h1' : 'Lab Assistant Jobs'
  },
  'Sports Trainer' : {
    'title' : 'Sports Trainer Jobs, Athletic Trainer',
    'description' : 'Sports Trainer Jobs, Athletic Trainer',
    'h1' : 'Sports Trainer Jobs'
  },
  'Soldering Operator' : {
    'title' : 'Soldering Operator Jobs, Fabrication',
    'description' : 'Soldering Operator Jobs, Fabrication',
    'h1' : 'Soldering Operator Jobs'
  },
  'Database/System/Linux Administrator' : {
    'title' : 'DBA Jobs, Database Administrator',
    'description' : 'DBA Jobs, Database Administrator',
    'h1' : 'Database/System/Linux Administrator Jobs'
  },
  'Program/Project Manager' : {
    'title' : 'Project Manager Jobs, Program Manager',
    'description' : 'Project Manager Jobs, Program Manager',
    'h1' : 'Program/Project Manager Jobs'
  },
  'Product Manager' : {
    'title' : 'Product Manager',
    'description' : 'Product Manager',
    'h1' : 'Product Manager Jobs'
  },
  'Data Scientist' : {
    'title' : 'Data Scientist Jobs, Hadoop',
    'description' : 'Data Scientist Jobs, Hadoop',
    'h1' : 'Data Scientist Jobs'
  },
  'Software Architect' : {
    'title' : 'Software Jobs, Software Architect',
    'description' : 'Software Jobs, Software Architect',
    'h1' : 'Software Architect Jobs'
  },
  'Market Research Analyst' : {
    'title' : 'Market Research Analyst Jobs, Data Analyst',
    'description' : 'Market Research Analyst Jobs, Data Analyst',
    'h1' : 'Market Research Analyst Jobs'
  },
  'Business Analyst' : {
    'title' : 'Business Analyst',
    'description' : 'Business Analyst',
    'h1' : 'Business Analyst Jobs'
  },
  'SAP Consultant' : {
    'title' : 'SAP Jobs, SAP Consultant',
    'description' : 'SAP Jobs, SAP Consultant',
    'h1' : 'SAP Consultant Jobs'
  },
  'Ward Boy' : {
    'title' : 'Ward Boy Jobs, Male Nurse',
    'description' : 'Ward Boy Jobs, Male Nurse',
    'h1' : 'Ward Boy Jobs'
  },
  'MIS Executive' : {
    'title' : 'MIS Jobs, Advanced Excel',
    'description' : 'MIS Jobs, Advanced Excel',
    'h1' : 'MIS Executive Jobs'
  },
  'Purchase Executive' : {
    'title' : 'Purchase Jobs, Procurement',
    'description' : 'Purchase Jobs, Procurement',
    'h1' : 'Purchase Executive Jobs'
  },
  'Packing Officer/Packing Executive/Packaging Technologist' : {
    'title' : 'Packaging Jobs, Packing',
    'description' : 'Packaging Jobs, Packing',
    'h1' : 'Packing Officer/Packing Executive/Packaging Technologist Jobs'
  },
  'Safety Officer' : {
    'title' : 'Safety Jobs, Safety Officer',
    'description' : 'Safety Jobs, Safety Officer',
    'h1' : 'Safety Officer Jobs'
  },
  'Pest Control Executive' : {
    'title' : 'Pest Control',
    'description' : 'Pest Control',
    'h1' : 'Pest Control Executive Jobs'
  },
  'Fire Fighter' : {
    'title' : 'Fire Fighter, Entry Level Fire Fighter',
    'description' : 'Fire Fighter, Entry Level Fire Fighter',
    'h1' : 'Fire Fighter Jobs'
  },
  'Swimming Pool Attendant/Life Guard' : {
    'title' : 'Life Guard Jobs, Pool Attendant',
    'description' : 'Life Guard Jobs, Pool Attendant',
    'h1' : 'Swimming Pool Attendant/Life Guard Jobs'
  },
  'Control Room Operator' : {
    'title' : 'Control Room Operator',
    'description' : 'Control Room Operator',
    'h1' : 'Control Room Operator Jobs'
  },
  'Medical Representative' : {
    'title' : 'Medical Representative',
    'description' : 'Medical Representative job',
    'h1' : 'Medical Representative Jobs'
  }
};



// WEBPACK FOOTER //
// ../q-jobs/src/assets/roleKeywords.js